function popupNewsletter() {
  // Variables générales
  const popupButton = document.querySelector('.header-right__icon--newsletter');
  const popup = document.querySelector('.newsPopup');
  const closeButton = document.querySelector('.newsPopup__fullContainer__box__closeButton');
  const outOfBox = document.querySelector('.newsPopup__fullContainer');
  const inTheBox = document.querySelector('.newsPopup__fullContainer__box');

  // Affichage popup au clic sur icone
  popupButton.addEventListener('click', function(){
    popup.classList.remove('js-hidden');
  });

  closeButton.addEventListener('click', function(){
    popup.classList.add('js-hidden');
  });


  // Fermer la popup : bouton et clic extérieur

  outOfBox.addEventListener('click', function(e){
    if (inTheBox.contains(e.target)) {
      return;
    } else {
      popup.classList.add('js-hidden');
    }
  });


  // Reprise texte bouton

  // const validButton = document.querySelector('.gform_footer input');
  // const acceptMsg = inTheBox.querySelector('.gfield_checkbox label');
  // acceptMsg.innerHTML = inTheBox.querySelector('.accept_message').innerHTML;
  //
  // validButton.setAttribute('value', inTheBox.querySelector('.button_text').getAttribute('value'));
}

module.exports = popupNewsletter;
